"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchesQuery = void 0;
var queryString = require('query-string');
/**
 * Example Calls:
 * matchesQuery(location.search, "destination") => Does the query contain the key "destination"?
 * matchesQuery(location.search, {adults: 2}) => Does the query contain the key "adults" with the value "2"?
 * matchesQuery(location.search, ["startDate", "endDate"] ) => Does the query contain both startDate and endDate keys?
 * matchesQuery(location.search, [{regionid: 179993}, "foobar"]) => Does the query contain a key of "regionid"
 * with a value of 179993, AND a key of foobar (with any value)?
 */
var matchesQuery = function (locationSearch, specification) {
  // Accept locationSearch as either a string, or a parsed query object.
  var queryObj = typeof locationSearch === 'string' ? queryString.parse(locationSearch) : locationSearch;
  var queryObjKeys = Object.keys(queryObj);
  // If passed a string, find that query key's existance
  if (typeof specification === 'string') {
    return queryObjKeys.includes(specification);
  }
  // If passed an array, test each entry
  if (typeof specification === 'object' && Array.isArray(specification)) {
    return specification.reduce(function (matchesAll, item) {
      return matchesAll && (0, exports.matchesQuery)(queryObj, item);
    }, true);
  }
  // If passed an object, test against both keys and values
  if (typeof specification === 'object') {
    return Object.keys(specification).reduce(function (matchesAll, key) {
      var queryValue = specification[key];
      // Does the key exist in the location search
      var matchesKey = queryObjKeys.includes(key);
      if (!matchesKey) {
        return false;
      }
      // Does the value of that key match the desired value
      var matchesValue = false;
      if (typeof queryValue === 'function') {
        matchesValue = queryValue(queryObj[key]);
      } else {
        matchesValue = queryObj[key] === queryValue.toString();
      }
      return matchesAll && matchesValue;
    }, true);
  }
  return false;
};
exports.matchesQuery = matchesQuery;